import React from "react";

function Dropdown() {
  return (
    <datalist id="types">
      <option value="Subhash Nagar" />
      <option value="Tagore Garden" />
      <option value="Rajouri Garden" />
      <option value="Ramesh Nagar" />
      <option value="Moti Nagar" />
      <option value="Kirti Nagar" />
      <option value="Shadipur" />
      <option value="Patel Nagar" />
      <option value="Rajendra Place" />
      <option value="Karol Bagh" />
      <option value="Jhandewalan" />
      <option value="Ramakrishna Ashram Marg" />
      <option value="Rajiv Chowk" />
    </datalist>
  );
}

export default Dropdown;
